module.exports = __webpack_public_path__ + "img/select-arrow.8207a412.svg";